import { XMarkIcon } from "@heroicons/react/20/solid";
import type { ReactNode } from "react";

import type { EntryColor } from "~/modules/dashboard/components/TimeTrackingCalendar/entryStyles.ts";

type Props = {
	color: EntryColor;
	title: string;
	subtitle: string;
	onClose: () => void;
	children: ReactNode;
};

/** The open entry: a white card with a stripe in the type color. The month shows it in a popover, the day view in place. */
export function EntryCard({ color, title, subtitle, onClose, children }: Props) {
	return (
		<div className="w-full overflow-hidden rounded-lg bg-white text-left shadow-md ring-1 ring-gray-200 md:shadow-lg">
			<div className={`h-1.5 ${color.solid}`} />
			<div className="flex flex-col gap-2 p-3 text-sm">
				<div className="flex items-start gap-2">
					<span className={`mt-1.5 size-2 shrink-0 rounded-full ${color.solid}`} />
					<div className="min-w-0 flex-1">
						<div className="break-words font-semibold leading-5">{title}</div>
						<div className="text-xs text-gray-500">{subtitle}</div>
					</div>
					<button type="button"
							aria-label="Schließen"
							className="text-gray-400 hover:text-gray-700"
							onClick={onClose}>
						<XMarkIcon className="size-5" />
					</button>
				</div>
				{children}
			</div>
		</div>
	);
}
